import React from 'react';
import Partner1 from '../assets/microsoft.png';
import Partner2 from '../assets/imprtechnologieslogo.png';
import Partner3 from '../assets/dell.png';
import Partner4 from '../assets/cisco.png';
import Partner5 from '../assets/apc.png';
import Partner6 from '../assets/hikv.png';
import Partner7 from '../assets/veeam.png';
import Partner8 from '../assets/zamtel.png';
import Partner9 from '../assets/lenovo.png';
import Partner10 from '../assets/google.png';
import Partner11 from '../assets/fortnet.png';
import Partner12 from '../assets/aws.png';


const partners = [
  { name: 'Partner 1', logo: Partner1, },
  { name: 'Partner 2', logo: Partner2,  },
  { name: 'Partner 3', logo: Partner3,  },
  { name: 'Partner 4', logo: Partner4,  },
  { name: 'Partner 2', logo: Partner5,  },
  { name: 'Partner 3', logo: Partner6,  },
  { name: 'Partner 4', logo: Partner7,  },
  { name: 'Partner 4', logo: Partner8,  },
  { name: 'Partner 2', logo: Partner9,  },
  { name: 'Partner 3', logo: Partner10,  },
  { name: 'Partner 4', logo: Partner11,  },
  { name: 'Partner 4', logo: Partner12,  },
  // Add more partners as needed
];

function PartnersPage() {
  return (
    <div className="w-full bg-white text-gray-900 p-6 mt-8">
      <div className="container mx-auto text-center">
        <h1 className="text-4xl mb-8 text-blue-800">Our Partners</h1>

        <div className="grid grid-cols-2 justify-content sm:grid-cols-3 md:grid-cols-6 gap-8">
          {partners.map((partner, index) => (
            <a 
              key={index} 
              href={partner.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center transition-transform duration-300 transform hover:scale-105"
            >
              <img 
                src={partner.logo} 
                alt={partner.name} 
                className="max-w-full h-24 object-contain"
                style={{ maxHeight: '50px', maxWidth: '120px' }} 
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PartnersPage;
